/* eslint-disable no-unused-vars */
import axios from "utils/httpClient";
import React, { useState, useEffect } from "react";
import { Collapse, Modal, ModalBody } from "reactstrap";
import { makeStyles } from "@material-ui/core/styles";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import "bootstrap/dist/css/bootstrap.min.css";
import CardFooter from "components/Card/CardFooter.js";
import CardIcon from "components/Card/CardIcon.js";
import Icon from "@material-ui/core/Icon";
import KeyboardIcon from '@material-ui/icons/Keyboard';
import Button from "components/CustomButtons/Button.js";
import Search from "@material-ui/icons/Search";
import CustomInput from "components/CustomInput/CustomInput.js";
import TSSelect from "components/Forms/TSSelect2";
import styles2 from "assets/jss/material-dashboard-react/views/dashboardStyle.js";
import { width } from "@material-ui/system";
import { Save } from "@material-ui/icons";
import { Checkbox } from "@material-ui/core";

const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: '"Sarabun", sans-serif',
    marginBottom: "3px",
    textDecoration: "none"
  },
  iconFile: {
    width: "32px",
    maxWidth: "100%"
  }
};

const useStyles = makeStyles(styles);
const useStyles2 = makeStyles(styles2);

export default function Vaccine2(props) {
  const VaccineEventKey = (props.match.params.VaccineEventKey !== undefined) ? props.match.params.VaccineEventKey : null;
  var moment = require('moment');
  require('moment/locale/th');

  const classes = useStyles();
  const classes2 = useStyles2();
  const [Search1, setSearch1] = useState([]);
  const [SerialNo, setSerialNo] = useState("");
  const [LotNo, setLotNo] = useState("");
  const [ExpiredDate, setExpiredDate] = useState("");
  const [name, setName] = useState("");
  const [lastName, setLastName] = useState("");
  const [EmployeeID, setEmployeeID] = useState("");
  const [SBP, setSBP] = useState(1);
  const [VaccineID, setVaccineID] = useState(null);
  const [DBP, setDBP] = useState(1);
  const [Temp, setTemp] = useState(null);
  const [PR, setPR] = useState(1);
  const [RR, setRR] = useState(null);
  const [Height, setHeight] = useState(null);
  const [Weight, setWeight] = useState(null);
  const [CheckColor, setCheckColor] = useState('white');

  const [lOption, setLOption] = useState([]);
    //const [option, setOption] = useState(null)
    const [Injector, setInjector] = useState(null);

  const [modal, setModal] = useState(false);
  const [isCheckPerson, setIsCheckPerson] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [errMsg, setErrMsg] = useState([]);
  const [modalError, setModalError] = useState(false);
  const [icon, setIcon] = useState("far fa-question-circle");

    const [FullName, setFullName] = useState("");

    //const urgentList = [{ label: "ปกติ", value: 0 }, { label: "ด่วน", value: 1 }, { label: "ฉุกเฉิน", value: 2 }];
    //const urgentList = [{ label: "1. สุภาวดี", value: 2 }, { label: "2. เปรมใจ", value: 7 }, { label: "3. อภิรักษ์", value: 5 }, { label: "4. จตุพร", value: 4 }, { label: "5. จิรวรรณ", value: 20 }, { label: "6. สลักจิตร", value: 21 }, { label: "7. อลิษา", value: 6 }, { label: "8. ยุภารัตน์", value: 22 }, { label: "9. พ.ญ.นริศรา", value: 9 }, { label: "10. สิริมา", value: 8 }, { label: "11. กาญจนา", value: 3 }, { label: "12. นฤมล", value: 18 }, { label: "13. พญ. กนกกร", value: 11 }, { label: "14. นพ.สุตศรัญ", value: 23 }, { label: "15. พญ.ชนกนันท์", value: 24 }];
    const urgentList = [
        {
            label: "1. สุภาวดี",
            value: 2
        },
        {
            label: "2. เปรมใจ",
            value: 7
        },
        {
            label: "3. อภิรักษ์",
            value: 5
        },
        {
            label: "4. จตุพร",
            value: 4
        },
        {
            label: "5. จิรวรรณ",
            value: 20
        },
        {
            label: "6. สลักจิตร",
            value: 21
        },
        {
            label: "7. อลิษา",
            value: 6
        },
        {
            label: "8. ยุภารัตน์",
            value: 22
        },
        {
            label: "9. พญ. นริศรา",
            value: 9
        },
        {
            label: "10. สิริมา",
            value: 8
        },
        {
            label: "11. กาญจนา",
            value: 3
        },
        {
            label: "12. นฤมล",
            value: 18
        },
        {
            label: "13. พญ. กนกกร",
            value: 11
        },
        {
            label: "14. นพ.สุตศรัญ",
            value: 23
        },
        {
            label: "15. พญ. ชนกนันท์",
            value: 24
        },
        {
            label: "16. กรรณิการ์",
            value: 1
        },
        {
            label: "17. เยาวภา",
            value: 25
        },
        {
            label: "18. จันทร์ทราทิพย์(สสจ.)",
            value: 28
        },
        {
            label: "19. ศศิฤดี(รพ.ตรัง)",
            value: 29
        },
        {
            label: "20. รักศิริ(รพ.ตรัง)",
            value: 30
        },
        {
            label: "21. ณภาภัช(รพ.ตรัง)",
            value: 31
        },
        {
            label: "22. วลัยรัตน์(สสจ.)",
            value: 32
        },
        {
            label: "23. นันทนาถ(สสจ.)",
            value: 33
        },
        {
            label: "24. อ.มุขรินทร์ (วพบ.)",
            value: 34
        },
        {
            label: "25. อ.นัสมา(วพบ.)",
            value: 35
        },
        {
            label: "26. ศิริขวัญ",
            value: 15
        },
        {
            label: "27. อำภา",
            value: 16
        },
        {
            label: "28. นิฤมล",
            value: 17
        },
        {
            label: "29. ปุณญิกา",
            value: 19
        },
        {
            label: "30. นุชนภางค์ เกิดรักษ์",
            value: 36
        },
        {
            label: "31. มนทิพย์  หนูเอียด",
            value: 37
        },
        {
            label: "32. พรทิพย์ รัตน์หิรัญ",
            value: 38
        },
        {
            label: "33. ยวนจิตร  ข่ายม่าน",
            value: 39
        },
        {
            label: "34. ลักขณา  จิตราวุธ",
            value: 40
        },
        {
            label: "35. มยุรี  นาเลื่อน",
            value: 41
        },
        {
            label: "36. พรรณี  คุณาธรรม",
            value: 42
        },
        {
            label: "37. นงลักษณ์ บินสตีระ",
            value: 43
        },
        {
            label: "38. ยินดี  หุ้นย่อง",
            value: 44
        },
        {
            label: "39. ชยากร   โสะหาบ",
            value: 45
        },
        {
            label: "40. วิไลกรณ์",
            value: 46
        },
        {
            label: "41. สุมลรัตน์(สสอ)",
            value: 47
        },
        {
            label: "42. วิภาวี(สสอ)",
            value: 48
        },
        {
            label: "43. อมรรัตน์(สสอ)",
            value: 49
        }    
        ,
        {
            label: "44. อรอนงค์  ชูหวยทอง",
            value: 50
        }
        ,
        {
            label: "51. สุภาพร  อนุพงศ์เมธี",
            value: 51
        }
        ,
        {
            label: "52. แขไข สุทธิจัน",
            value: 52
        }
        ,
        {
            label: "53. กรกช  เพทาย",
            value: 53
        }
        ,
        {
            label: "54. จริต  อัศวชาญชัยสกุล",
            value: 54
        }
        ,
        {
            label: "55. ชุติมา  สุพิทักษ์",
            value: 55
        },
        {
            label: "56. วราตรี  พลอินทร์",
            value: 56
        },
        {
            label: "57. ผจงวรรณ  จริงจิตร",
            value: 57
        },
        {
            label: "หมอตุล",
            value: 14
        }





    ];

    useEffect(() => {


      const requestOptions = {
          method: "GET",
      };





  }, []);


    const SendTab = (event, id) => {
        if (event.key === 'Enter') {
            if (id != "btnSubmit")
                document.getElementById(id).focus();  
            else if (id == "btnSubmit" && isCheckPerson)
                document.getElementById(id).focus();  
        }
    }

  const handleKeyDown = (event) => {

      if (event.key === 'Enter') {
          setCheckColor('white');

          var isCall = false;

          if (Search1.length == 5 || Search1.length == 13) {
              // 5 หรือ 13 หลัก ให้ค้นชื่อ
              isCall = true;

          }
          else if (Search1.length == 20) {
              setSerialNo(Search1);
              
              isCall = (EmployeeID == null || EmployeeID == '');

              setSearch1('');
          }

          if (isCall) {

              const requestOptions = {
                  method: "GET"
              };

              axios("/api/trs/employee2/" + VaccineEventKey + "/" + Search1, requestOptions)
                  .then(response => response.data)
                  .then(
                      result => {

                          setFullName(result.titleName + ' ' + result.firstName + ' ' + result.lastName);
                          setEmployeeID(result.employeeID);
                          /*
                          if (result.employeeID == '3929800028214')
                          {
                              setCheckColor('blue');
                              alert('blue')
                          }
                          else {
                              setCheckColor('green');
                          }
                          */
                          if (result.trsVaccine.length > 0) {
                              var vc = result.trsVaccine[0];


                              if (vc.trsVaccineID == '00000000-0000-0000-0000-000000000000') {
                                  //setIsAutoSave(true);
                              }
                              else {
                                  if (vc.serialNo != null) {
                                      setSerialNo('');
                                      setSerialNo(vc.serialNo);
                                  }
                              }

                              setHeight('');
                              setWeight('');
                              setTemp('');
                              setSBP(1);
                              setDBP(1);
                              setPR(1);
                              setRR('');

                              setVaccineID(vc.trsVaccineID);
                              setLotNo(vc.lotNo);
                              //setExpiredDate(moment(vc.expiredDate).format('YYYY-MM-DD'));
                              setHeight(vc.height);
                              setWeight(vc.weight);
                              setTemp(vc.temp);

                              (vc.systolicBP == null || vc.systolicBP == '') ? setSBP(1) : setSBP(vc.systolicBP);
                              (vc.diastolicBP == null || vc.diastolicBP == '') ? setDBP(1) : setDBP(vc.diastolicBP);
                              (vc.setPR == null || vc.setPR == '') ? setPR(1) : setPR(vc.setPR);

                              setRR(vc.rr);

                              if (!isCheckPerson)
                                setInjector(vc.injectorKey);

                              setSearch1('');
                          }
                          else {
                              //setCheckColor('red');
                              //setIsAutoSave(true);
                              setVaccineID('00000000-0000-0000-0000-000000000000');

                              //setSerialNo('');

                              setLotNo('');
                              setExpiredDate('')
                              setHeight('');
                              setWeight('');
                              setTemp('');
                              setSBP(1);
                              setDBP(1);
                              setPR(1);
                              setRR('');
                              if (!isCheckPerson)
                                  setInjector(0);


                              setSearch1('');
                          }

                          //setModal(false);
                          //setIcon("far fa-question-circle");
                      },
                      error => {
                          //setCheckColor('orange');
                          //setIsAutoSave(true);
                          //alert("ไม่มีข้อมูลผู้ฉีดวัคซีน");
                          setFullName('');
                          setEmployeeID('');
                          setVaccineID('00000000-0000-0000-0000-000000000000');
                          //setSerialNo('');
                          setLotNo('');
                          setExpiredDate('')
                          setHeight('');
                          setWeight('');
                          setTemp('');
                          setSBP(1);
                          setDBP(1);
                          setPR(1);
                          setRR('');
                          if (!isCheckPerson)
                              setInjector(0);
                          setSearch1('');

                      }
                  );
          }
         
      }
  }

  const handleSearch = (e) => {
      console.log(e);

  };

  const handleSubmit = evt => {
    evt.preventDefault();
    var cntErr = 0;

        var txtErr = 'กรุณา\r\n';
        //if (isAutoSave) {

            if (SerialNo == null || SerialNo == '') {
                txtErr += 'ระบุ Serial No.\r\n';
                cntErr += 1;
            }
            if (EmployeeID == null || EmployeeID == '') {
                txtErr += 'ค้นหาบุคคล\r\n';
                cntErr += 1;
            }
            if (Injector == null || Injector == '' || Injector == 0) {
                txtErr += 'ระบุผู้ฉีด\r\n';
                cntErr += 1;
            }
            if (Temp == null || Temp == '') {
                txtErr += 'ระบุอุณหภูมิ\r\n';
                cntErr += 1;
            }
            if (SBP == null || SBP == '') {
                txtErr += 'ระบุความดัน SBP\r\n';
                cntErr += 1;
            }
            if (DBP == null || DBP == '') {
                txtErr += 'ระบุความดัน DBP\r\n';
                cntErr += 1;
            }
            if (PR == null || PR == '') {
                txtErr += 'ระบุ PR\r\n';
                cntErr += 1;
            }
            if (Weight == null || Weight == '') {
                txtErr += 'ระบุน้ำหนัก\r\n';
                cntErr += 1;
            }
            if (Height == null || Height == '') {
                txtErr += 'ระบุส่วนสูง\r\n';
                cntErr += 1;
            }

            if (cntErr > 0) {
                alert(txtErr);
            } else {
                //setModal(true);
                handleConfirm();
            }
  };
    const handleClear = evt => {
      setFullName('');
      setEmployeeID('');
      setSearch1('');
      setVaccineID('00000000-0000-0000-0000-000000000000');
      setSerialNo('');
      setLotNo('');
      setExpiredDate('')
      setHeight('');
      setWeight('');
      setTemp('');
      setSBP(1);
      setDBP(1);
      setPR(1);
      setRR('');
      if (!isCheckPerson)
        setInjector(0);

  };
  const isCheck = () => {
  
  };

  const handleConfirm = (/*evt*/) => {
    //evt.preventDefault();
    setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json"
      },
      data: {
          trsVaccineID: (VaccineID != null) ? VaccineID : '00000000-0000-0000-0000-000000000000',
          employeeID: EmployeeID,
          vaccineEventKey: VaccineEventKey,
          serialNo: SerialNo,
          lotNo: LotNo,
          expiredDate: ExpiredDate,
          height: Height,
          weight: Weight,
          temp: Temp,
          pr: PR,
          systolicBP: SBP,
          diastolicBP: DBP,
          rr: RR,
          injectorKey: Injector
      }
    };

      axios("/api/trs/vaccine/" , requestOptions)
      .then(response => response.data)
      .then(
          result => {
              alert(JSON.stringify(result));
              //window.location.href = '/admin/vaccine';
              
              setModal(false);
              setIcon("far fa-question-circle");

              setFullName('');
              setEmployeeID('');
              setSearch1('');
              setVaccineID('00000000-0000-0000-0000-000000000000');
              setSerialNo('');
              setLotNo('');
              setExpiredDate('')
              setHeight('');
              setWeight('');
              setTemp('');
              setSBP(1);
              setDBP(1);
              setPR(1);
              setRR('');
              if (!isCheckPerson)
                  setInjector(0);

              document.getElementById("txtSearch").focus();  
        },
          error => {
              alert('ไม่สามารถบันทึกได้')
              setFullName('');
              setEmployeeID('');
              setSearch1('');
              setVaccineID('00000000-0000-0000-0000-000000000000');
              setSerialNo('');
              setLotNo('');
              setExpiredDate('')
              setHeight('');
              setWeight('');
              setTemp('');
              setSBP(1);
              setDBP(1);
              setPR(1);
              setRR('');
              if (!isCheckPerson)
                  setInjector(0);
            alert(error);
            setModal(false);
            setIcon("far fa-question-circle");
        }
      );
  };


  return (
      <div style={{ backgroundColor: CheckColor }}>
      <GridContainer>
              <GridItem xs={12} sm={12} md={12} >
                <Card>
                      <CardHeader color="warning" stats icon>
                          <h4 style={{ color: 'black' }}> Scan Serial Number, หรือ Scan QRCode ใบนำทางก่อนก็ได้ (หรือ Key เลขบัตร 13 หลัก, ลำดับ 5 หลัก) </h4>
                          <CardIcon color="info">
                              <Icon>
                                  <KeyboardIcon />
                              </Icon>
                          </CardIcon>
                          <div className={classes.searchWrapper} xs={12} sm={12} md={12}>
                              <CustomInput
                                  labelText="Scan"
                                  formControlProps={{
                                      style: {width:'400px'},
                                      fullWidth: false
                                  }}
                                  id="txtSearch"
                                  onChange={e => setSearch1(e)}
                                  value={Search1}
                                  onKeyDown={handleKeyDown}
                              />
                              <Button
                                  color="white"
                                  aria-label="edit"
                                  justIcon
                                  round
                                  onClick={() => handleSearch()}
                              >
                                  <Search />
                              </Button>
                          </div>
                      </CardHeader>

          <CardBody>
            <GridContainer>
{/*
            <GridItem xs={12} sm={6} md={6}>
                <CustomInput
                    labelText="ชื่อ"
                    id="name"
                    formControlProps={{
                        fullWidth: true
                    }}
                    onChange={e => setName(e)}
                    value={name}
                />
            </GridItem>
            <GridItem xs={12} sm={6} md={6}>
                <CustomInput
                    labelText="นามสกุล"
                    id="lastName"
                    formControlProps={{
                        fullWidth: true
                    }}
                    onChange={e => setLastName(e)}
                    value={lastName}
                />
                              </GridItem>
*/}                
                <GridItem xs={12} sm={12} md={12}>
                 <h3 className={classes2.cardTitle} >
                 ชื่อ : {EmployeeID} {FullName}
                 </h3>
                <h3 className={classes2.cardTitle} >
                   Serial No : {SerialNo}
                 </h3>
                </GridItem>

                <GridItem style={{ display: 'none' }} xs={12} sm={4} md={4}>
                Lot No.
                <CustomInput
                    //labelText="Lot No."
                    id="lotNo"
                    formControlProps={{
                        fullWidth: true
                    }}
                    onChange={e => setLotNo(e)}
                    value={LotNo}
                />
             </GridItem>
             <GridItem style={{ display: 'none' }} xs={12} sm={4} md={4}>
             Expired
                <CustomInput
                    //labelText="Expired"
                    id="expiredDate"
                    formControlProps={{
                        fullWidth: true
                    }}
                    onChange={e => setExpiredDate(e)}
                    value={ExpiredDate}
                />
             </GridItem>
            
               <GridItem xs={12} sm={3} md={3}>
                Temp                  
                <CustomInput
                    //labelText="Temp"
                    id="Temp"
                    formControlProps={{
                        fullWidth: true
                    }}
                    onChange={e => setTemp(e)}
                    value={Temp}
                    numericInput={true}
                    onKeyDown={e => SendTab(e, "Weight") }
                />
            </GridItem>
            <GridItem xs={6} sm={3} md={3}>
             SBP
                <CustomInput
                    //labelText="SBP"
                    id="SBP"
                    formControlProps={{
                        fullWidth: true
                    }}
                    onChange={e => setSBP(e)}
                    value={SBP}
                                      integerNumber={true}
                                      onKeyDown={e => SendTab(e, "DBP")}
                />
            </GridItem>
            <GridItem xs={6} sm={3} md={3}>
            DBP
                <CustomInput
                    //labelText="DBP"
                    id="DBP"
                    formControlProps={{
                        fullWidth: true
                    }}
                    onChange={e => setDBP(e)}
                    value={DBP}
                                      integerNumber={true}
                                      onKeyDown={e => SendTab(e, "PR")}
                />
            </GridItem>

                <GridItem xs={6} sm={3} md={3}>
                PR
                <CustomInput
                    //labelText="PR"
                    id="PR"
                    formControlProps={{
                        fullWidth: true
                    }}
                    onChange={e => setPR(e)}
                    value={PR}
                                      integerNumber={true}
                                      onKeyDown={e => SendTab(e, "Weight")}
                />
            </GridItem>
            <GridItem style={{ display: 'none' }} xs={6} sm={3} md={3}>
            RR
                <CustomInput
                    //labelText="RR"
                    id="RR"
                    formControlProps={{
                        fullWidth: true
                    }}
                    onChange={e => setRR(e)}
                    value={RR}
                    integerNumber={true}
                />
                              </GridItem>

                              <GridItem xs={12} sm={4} md={4}>
                                  Weight
                                  <CustomInput
                                      //labelText="Weight"
                                      id="Weight"
                                      formControlProps={{
                                          fullWidth: true
                                      }}
                                      onChange={e => setWeight(e)}
                                      value={Weight}
                                      numericInput={true}
                                      onKeyDown={e => SendTab(e, "Height")}
                                  />
                              </GridItem>
                              <GridItem xs={12} sm={4} md={4}>
                                  Height
                                  <CustomInput
                                      //labelText="Height"
                                      id="Height"
                                      formControlProps={{
                                          fullWidth: true
                                      }}
                                      onChange={e => setHeight(e)}
                                      value={Height}
                                      numberOnly={true}
                                      onKeyDown={e => SendTab(e, "btnSubmit")}
                                  />
                              </GridItem>
                             
                     
                              <GridItem xs={12} sm={4} md={4}>
                                  <TSSelect label="ผู้ฉีดวัคซีน" options={urgentList} value={Injector} placeholder="ค้นหา" onChange={e => setInjector(e.value)} />
                                 
                                  <input type="checkbox"
                                      onChange={() => setIsCheckPerson(!isCheckPerson)}
                                  /> ไม่เปลี่ยนผู้ฉีด  {Injector}
                              </GridItem>
                                     
                                      
                            
                              
            </GridContainer>
            <GridContainer style={{ backgroundColor: CheckColor }}>
                <GridItem style={{ marginTop: "20px" }} xs={12} sm={6} md={6}>
                    <Button color="primary" onClick={handleSubmit} id="btnSubmit">
                        <h4>บันทึก</h4>
                    </Button>
                 </GridItem>
                              <GridItem style={{ marginTop: "20px", display:'none' }} xs={12} sm={6} md={6}>
                                  <Button color="primary" onClick={handleClear}>
                                      <h4>Clear</h4>
                                  </Button>
                              </GridItem>
            </GridContainer>
          </CardBody>
          <CardFooter>

            {/* Confirm */}
            <Modal toggle={() => setModal(false)} isOpen={modal}>
                <div className="modal-header justify-content-center">
                  <div>
                    <i
                      className={icon}
                      style={{ color: "blue", fontSize: "2em" }}
                    ></i>
                  </div>
                </div>
                <ModalBody>
                  <p
                    style={{
                      textAlign: "center"
                    }}
                  >
                    {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                      ? "ยืนยันการบันทึกข้อมูล"
                      : "กำลังตรวจสอบข้อมูล"}
                  </p>
                  <p> </p>
                </ModalBody>
                <div className="modal-footer">
                  <Button
                    color="primary"
                    type="button"
                    onClick={() => setModal(false)}
                  >
                    <h4>ยกเลิก</h4>
                  </Button>

                  <Button
                    color="primary"
                    type="button"
                    onClick={handleConfirm}
                    disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                  >
                    <h4>ยืนยัน</h4>
                  </Button>
                </div>
              </Modal>
          </CardFooter>
        </Card>
      </GridItem>
    </GridContainer>
    </div>
  );
}
